import React from 'react';
import { MainContainerLayout } from 'clorian-frontend-components';
import LoginContainer from '../containers/LoginContainer';

const LoginView = () => (
  <div>
    <MainContainerLayout>
      <LoginContainer />
    </MainContainerLayout>
  </div>
);

export default LoginView;
